import React from 'react';
import * as S from './CancelLeftBlock.styles';

import BreadCrumb from '../../common/BreadCrumb/BreadCrumb';
import CancellationHeader from './CancellationHeader/CancellationHeader';
import CancellationBody from './CancellationBody/CancellationBody';

const CancelLeftBlock = ({headerText, header, showTabs, activeTab, updateActiveTab, breakupList, freeCancellationText, selectedRefundMode, updateRefundMode, refundBreakUp, hotelDetails, confirmCancellation, showPayModeButton}) => {
  return(
    <S.LeftBlockMainWrap>
      <BreadCrumb />
      <S.LeftBlockOuterWrap>
        <CancellationHeader headerText={headerText} showTabs={showTabs} activeTab={activeTab} updateActiveTab={updateActiveTab} hotelDetails={hotelDetails} />
        <CancellationBody activeTab={activeTab}
          updateActiveTab={updateActiveTab}
          header={header}
          breakupList={breakupList}
          freeCancellationText={freeCancellationText}
          selectedRefundMode={selectedRefundMode}
          updateRefundMode={updateRefundMode}
          refundBreakUp={refundBreakUp}
          confirmCancellation={confirmCancellation}
          showPayModeButton={showPayModeButton}
        />
      </S.LeftBlockOuterWrap>
    </S.LeftBlockMainWrap>
  );
}

export default CancelLeftBlock;